<template>
    <div class='t_content_view'>
        <el-page-header @back="goBack" content="详情" />
        <div style="margin-top: 30px;margin-bottom: 30px;font-size: 15px;">
            批量导入手机号，自动尝试添加该手机号关联的微信
        </div>
        <div class="t_tab_box">
            <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane label="任务详情" name="first">
                    <rwxq />
                </el-tab-pane>
                <el-tab-pane label="导入数据" name="second">
                    <drsj />
                </el-tab-pane>
                <el-tab-pane label="申请记录" name="third">
                    <sqjl />
                </el-tab-pane>
                <el-tab-pane label="成功添加" name="fourth">
                    <cgtj />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
    
</template>

<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import rwxq from '../components/phonefrienddetail/rwxq.vue'
import drsj from '../components/phonefrienddetail/drsj.vue'
import sqjl from '../components/phonefrienddetail/sqjl.vue'
import cgtj from '../components/phonefrienddetail/cgtj.vue'
// import { allpeoselect } from '@/assets/js/common.js' // work/bcDepartment* 老接口已废弃
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
const goBack = () => {
    if(route.query.addType==1){
        router.push({ path: '/navtkyl/phonefriend' })
    }else if(route.query.addType==2){
        router.push({ path: '/navtkyl/phonefriendgth' })
    }
    
}
onMounted(() => {

})

//当前tab
const activeName = ref('first')
//点击当前tab
const handleClick = (tab,event)=>{
    console.log(tab,event)
}
    


</script>

<style scoped>
.t_tab_box{
    border: 1px solid #cdcdcd;
    padding-top: 20px;
}
:deep(.el-tabs__nav-scroll){
    padding-left: 30px;
}
:deep(.el-tabs__nav-wrap::after){
    height: 1px;
    background-color: #cdcdcd;
}
</style>